import { FC } from 'react'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { EActivityInfoPart, EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { IProgramPageQuestions } from '../types'
import UsersCommunication from '../../../../../../components/UsersCommunication/desktop'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import { useGetInstitutionsId } from '../bll/useGetInstitutionsId'

const ProgramPageQuestions: FC<IProgramPageQuestions> = (props) => {
  const { questions, total, id } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const { setUserActivity } = useUserActivity()

  const institutionId = useGetInstitutionsId()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId,
      data: { infoPart: EActivityInfoPart.questions },
      programId: id,
    })
  }

  if (!questions) return null

  return (
    <LimitedList
      id='questions'
      items={questions}
      isAuth={isAuth}
      buttonText='Показать ещё'
      limit={3}
      showMore
      onShowAll={handleShowAllClick}
    >
      {({ limitedItems }) => {
        return (
          <UsersCommunication
            items={limitedItems}
            type='questions'
            total={total}
            rootId={id}
            rootType='program'
          />
        )
      }}
    </LimitedList>
  )
}

export default ProgramPageQuestions
